<template>
    <section class="content-section">
        <div class="about-market" ref="market">
            <b-img src="@/assets/images/about/market.jpg" :class="{ showClass: show}" fluid></b-img>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            showClass:{
                opacity: 1,
                transform: 'scale(1)'
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollHandle);
    },
    methods: {
        scrollHandle(e) {
            let { top } = this.$refs.market.getBoundingClientRect()
            if(top < 360) {
                this.show = true
            }
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollHandle)
    },
}
</script>

<style lang="scss">
    .about-market{
        background-size: cover;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-image: url("~@/assets/images/about/market_bg.jpg");

        img{
            display: block;
            width: 90%;
            margin: 0 auto;
            transition: transform 1s;
            opacity: 0;
            transform: scale(0.2);

            &.showClass{
                opacity: 1;
                transform: scale(1);
            }
        }
        @media (min-width: 992px) {
            .about-market{
                min-height: 500px;
            }
            img{
                width: 70%
            }
        }
    }
</style>